/* global axios */
import ApiClient from '../ApiClient';

// All endpoints proxy to wa_bridge through Rails. Bridge URL/secret never reach the browser.
class BaileysChannel extends ApiClient {
  constructor() {
    super('whatsapp/baileys', { accountScoped: true });
  }

  // Reads
  status(inboxId) {
    return axios.get(`${this.url}/status`, { params: { inbox_id: inboxId } });
  }

  qr(inboxId) {
    return axios.get(`${this.url}/qr`, { params: { inbox_id: inboxId } });
  }

  events(inboxId, limit = 50) {
    return axios.get(`${this.url}/events`, { params: { inbox_id: inboxId, limit } });
  }

  metrics(inboxId) {
    return axios.get(`${this.url}/metrics`, { params: { inbox_id: inboxId } });
  }

  health(inboxId) {
    return axios.get(`${this.url}/health`, { params: { inbox_id: inboxId } });
  }

  signalStats(inboxId) {
    return axios.get(`${this.url}/signal_stats`, { params: { inbox_id: inboxId } });
  }

  // Commands
  start(inboxId)        { return axios.post(`${this.url}/start`,         null, { params: { inbox_id: inboxId } }); }
  stop(inboxId)         { return axios.post(`${this.url}/stop`,          null, { params: { inbox_id: inboxId } }); }
  restart(inboxId)      { return axios.post(`${this.url}/restart`,       null, { params: { inbox_id: inboxId } }); }
  reconnect(inboxId)    { return axios.post(`${this.url}/reconnect`,     null, { params: { inbox_id: inboxId } }); }
  regenerateQr(inboxId) { return axios.post(`${this.url}/regenerate_qr`, null, { params: { inbox_id: inboxId } }); }
  logout(inboxId)       { return axios.post(`${this.url}/logout`,        null, { params: { inbox_id: inboxId } }); }
  reset(inboxId)        { return axios.post(`${this.url}/reset`,         null, { params: { inbox_id: inboxId } }); }
  clearMedia(inboxId)   { return axios.post(`${this.url}/clear_media`,   null, { params: { inbox_id: inboxId } }); }

  // Reset Signal session de um peer especifico (resolve Bad MAC sem logout total).
  purgePeer(inboxId, jid) {
    return axios.post(`${this.url}/purge_peer`, { jid }, { params: { inbox_id: inboxId } });
  }

  // Pair Code - alternativa ao QR. Retorna { code, phone }.
  pairCode(inboxId, phoneNumber) {
    return axios.post(`${this.url}/pair_code`, { phone_number: phoneNumber }, { params: { inbox_id: inboxId } });
  }

  // Identity (Fase 2)
  identity(inboxId) {
    return axios.get(`${this.url}/identity`, { params: { inbox_id: inboxId } });
  }
  updateIdentityName(inboxId, name) {
    return axios.post(`${this.url}/update_identity_name`, { name }, { params: { inbox_id: inboxId } });
  }
  updateIdentityStatus(inboxId, status) {
    return axios.post(`${this.url}/update_identity_status`, { status }, { params: { inbox_id: inboxId } });
  }
  updateIdentityPicture(inboxId, imageUrl) {
    return axios.post(`${this.url}/update_identity_picture`, { image_url: imageUrl }, { params: { inbox_id: inboxId } });
  }

  // Diagnostics (Fase 3)
  checkNumber(inboxId, phoneNumber) {
    return axios.post(`${this.url}/check_number`, { phone_number: phoneNumber }, { params: { inbox_id: inboxId } });
  }
  blocklist(inboxId) {
    return axios.get(`${this.url}/blocklist`, { params: { inbox_id: inboxId } });
  }
  blockContact(inboxId, jid, actionType) {
    return axios.post(`${this.url}/block_contact`, { jid, action_type: actionType }, { params: { inbox_id: inboxId } });
  }
  contactStatus(inboxId, jid) {
    return axios.get(`${this.url}/contact_status`, { params: { inbox_id: inboxId, jid } });
  }
}

export default new BaileysChannel();
